import React from 'react';
import { Create, SimpleForm, TextInput } from 'react-admin';

const VendorCreate = (props: any) => {
    return (
        <Create {...props}>
            <SimpleForm>
                <TextInput source='name' />
                <TextInput source='phoneNumber' />
                <TextInput source='category' />
            </SimpleForm>
        </Create>
    );
};

export default VendorCreate;